<template>
    <main id="mainCtrl">
        <v-table id="table"
                 request-uri="doctorAppreciations/getList"
                 pagesize="50"
                 :lazycount="true"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="created_at" sort="created_at" width="120">
                        Дата
                    </v-th>
                    <v-th name="amount" sort="amount" width="100">
                        Сумма
                    </v-th>
                    <v-th name="doctor_name" minwidth="200">
                        Врач
                    </v-th>
                    <v-th name="is_paid" sort="is_paid" width="100">
                        Оплата
                    </v-th>
                    <v-th name="source" minwidth="200">
                        Источник
                    </v-th>
                    <v-th name="user_phone" width="120">
                        Пользователь
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="created_at" v-slot="{filter}">
                        <date-piker v-model="filter.value"/>
                    </v-th>
                    <v-th name="amount" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="doctor_name" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="is_paid" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: '1', text: 'Оплачено' },
                                { value: '0', text: 'Не оплачено' },
                            ]"
                        />
                    </v-th>
                    <v-th name="source"/>
                    <v-th name="user_phone" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index }">
                <v-tr class="hover pointer" :id="'da-tr-' + item.id">
                    <v-td name="created_at" highlight="*">
                        {{ item.created_at | formatDateTime }}
                    </v-td>
                    <v-td name="amount" highlight="*">
                        {{ item.amount }} р.
                    </v-td>
                    <v-td name="doctor_name">
                        {{ item.doctor_name }}
                    </v-td>
                    <v-td name="is_paid" highlight="*">
                        {{ item.is_paid ? 'Оплачено' : 'Не оплачено' }}
                    </v-td>
                    <v-td name="source">
                        <span v-if="item.is_doctor_page">
                            Страница врача
                        </span>
                        <a v-else-if="item.question_url" :href="item.question_url" target="_blank">
                            {{ item.question_url }}
                        </a>
                    </v-td>
                    <v-td name="user_phone" highlight="*">
                        {{ item.user_phone }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
export default {
    methods: {

    },
}
</script>
